import { Target, TrendingDown, BarChart2, AlertTriangle, Map } from "lucide-react";

const items = [
  { icon: Target, text: "Your Growth Score (0–100) with letter grade" },
  { icon: TrendingDown, text: "Where you're leaking patients right now" },
  { icon: BarChart2, text: "Which channels are underperforming" },
  { icon: AlertTriangle, text: "What you're missing entirely" },
  { icon: Map, text: "A prioritized 90-day roadmap you can act on today" },
];

const LandingCallDetails = () => {
  return (
    <section className="py-16 md:py-20 bg-background">
      <div className="max-w-3xl mx-auto section-padding">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight mb-3 text-center">
          What You'll See
        </h2>
        <p className="text-muted-foreground text-center mb-10 max-w-xl mx-auto">
          No vague "insights." Specific numbers and actions for your practice.
        </p>
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.text} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-accent/10 flex items-center justify-center shrink-0 mt-0.5">
                <item.icon className="w-4 h-4 text-accent" />
              </div>
              <p className="text-foreground/90 font-medium">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingCallDetails;
